import { type CountriesAlpha2, type Currency } from '@sequencehq/api'

export const GOCARDLESS_UNSUPPORTED_CURRENCY_MESSAGE =
  'GoCardless does not support payments using the selected currency'

export const GOCARDLESS_UNSUPPORTED_COUNTRY_MESSAGE =
  'GoCardless does not support payments for the customers country'

export const GOCARDLESS_NO_CUSTOMER_MESSAGE =
  'Select a customer to enable GoCardless for this billing schedule'

export const GOCARDLESS_NO_PRODUCTS_MESSAGE =
  'Add a product to enable GoCardless for this billing schedule'

export const GOCARDLESS_CANNOT_REMOVE_LAST_PRODUCT_MESSAGE =
  'Cannot remove the last product while GoCardless is enabled for this billing schedule'

/**
 * Source: https://gocardless.com/faq/merchants/international-payments/
 */

export const GOCARDLESS_SUPPORTED_CURRENCIES: Currency[] = [
  'GBP',
  'EUR',
  'SEK',
  'DKK',
  'AUD',
  'NZD',
  'CAD',
  'USD'
]

export const NON_EUROZONE_COUNTRIES: CountriesAlpha2[] = [
  'GB',
  'SE',
  'DK',
  'AU',
  'NZ',
  'CA',
  'US'
]

export const SEPA_EUROZONE_COUNTRIES: CountriesAlpha2[] = [
  'AD', // Andorra
  'AT', // Austria
  'BE', // Belgium
  'HR', // Croatia
  'CY', // Cyprus
  'EE', // Estonia
  'FI', // Finland
  'AX', // Åland Islands
  'FR', // France
  'GF', // French Guiana
  'GP', // Guadeloupe
  'MQ', // Martinique
  'YT', // Mayotte
  'BL', // Saint Barthélemy
  'MF', // Saint Martin (French part)
  'RE', // Réunion
  'PM', // Saint Pierre and Miquelon
  'DE', // Germany
  'GR', // Greece
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'MC', // Monaco
  'NL', // Netherlands
  'PT', // Portugal
  'SM', // San Marino
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'VA' // Vatican City (Holy See)
]

export const SEPA_NON_EUROZONE_COUNTRIES: CountriesAlpha2[] = [
  'BG', // Bulgaria
  'CZ', // Czechia
  'DK', // Denmark
  'HU', // Hungary
  'IS', // Iceland
  'LI', // Liechtenstein
  'NO', // Norway
  'PL', // Poland
  'RO', // Romania
  'SE', // Sweden
  'CH', // Switzerland
  'GB', // United Kingdom
  'GI', // Gibraltar
  'GG', // Guernsey
  'JE', // Jersey
  'IM' // Isle of Man
]

export const GOCARDLESS_SUPPORTED_END_CUSTOMER_COUNTRIES: CountriesAlpha2[] = [
  ...NON_EUROZONE_COUNTRIES,
  ...SEPA_EUROZONE_COUNTRIES,
  ...SEPA_NON_EUROZONE_COUNTRIES
]
